<template>
<v-container>
  <v-card>
    <v-card-text>
      <v-card>
        <v-card-title>
          Financiación del Acuerdo Final de Paz
        </v-card-title>
        <v-card-text>
          <v-flex xs12 >
                  </v-flex>
          Conozca los recursos destinados para la financiación del Acuerdo Final de Paz:
          <v-tabs
            show-arrows
            next-icon="fa-caret-right"
            prev-icon="fa-caret-left"
            background-color="blue-grey lighten-4"
            horizontal
            v-model="TabSeleccionado"
            @change="ontabseleccionado"
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab subtitle-2 key="0">
              <div class="caption"> Marco Fiscal de Mediano Plazo </div>
            </v-tab>
            <v-tab key="1">
              <div class="caption"> Plan Plurianual de Inversiones para la Paz </div>
            </v-tab>
            <v-tab key="2">
              <div class="caption"> Presupuesto General de la Nación </div>
            </v-tab>
            <v-tab-item>
              <v-card>
                <v-card-title>
                  Montos indicativos para la implementación del Acuerdo Final de Paz <b>» Proyecciones 2017-2031 </b>
                </v-card-title>
                <v-card-text v-if="grmarcofiscal != undefined">   
                  Conozca los recursos financieros estimados para la implementación de los Acuerdos de Paz, por cada una de las fuentes de financiación y puntos.
                  <hr>
                  <br>
                  <dona titulo1="POR FUENTE DE FINANCIACIÓN" titulo2="POR PUNTO DEL ACUERDO" :avances1="marcofiscalfuente" :avances2="marcofiscalpunto" :cifras= "marcofiscalcifra.descripcion" nameseries1="nombre" nameseries2="nombre" id1="Mar1" id2="Mar2" />
                </v-card-text>
                <hr>
              <div class="Subtitle-2 text-center font-weight-bold"><a href="https://siipo.dnp.gov.co/file/Marco_Fiscal_de_Mediano_Plazo_2017.pdf" target="_blank">(MFMP 2017.)</a>__<a href="https://siipo.dnp.gov.co/file/Marco_Fiscal_de_Mediano_Plazo_2018.pdf" target="_blank">(MFMP 2018.)</a> </div>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <v-card-title >
                  <div v-if="periodoselect == '2018-2022'">
                    Plan Plurianual de Inversiones 2018-2022: Pacto por Colombia, Pacto por la Equidad.
                  </div>
                  <div v-else>
                      Plan Plurianual de Inversiones 2022-2026: ‘Colombia potencia mundial de la vida’
                  </div>
                </v-card-title>
                
                <v-card-text>
                  <v-flex row class="container">
                    <v-flex xs12 sm10 md10 >
                      Conozca los recursos financieros <b>estimados</b> en la implementación de los Acuerdos de Paz, para el cuatrienio {{periodoselect}}.
                    </v-flex>
                    <v-flex xs12 sm2 md2 >
                      <v-select
                        :items="recursoplurianual.periodos"
                        v-model="periodoselect"
                        item-text="nombre"
                        item-value="valor"
                        label="Periodo"
                      ></v-select>
                    </v-flex>
                  </v-flex>
                  <hr>
                  <br>
                    <dona :cifras= "recursoplurianual.cifras.filter(record => { return record.periodo == this.periodoselect; })[0].nombre" titulo1="POR FUENTE DE FINANCIACIÓN" titulo2="POR PUNTO DEL ACUERDO" :avances1="recursoplurianual.general.fuente.filter(record => { return record.periodo == this.periodoselect; })" :avances2="recursoplurianual.general.punto.filter(record => { return record.periodo == this.periodoselect; })" nameseries1="nombre" nameseries2="nombre" id1="PluG1" id2="PluG2" />
                </v-card-text>
              </v-card>
              <hr>
              <div class="Subtitle-2 text-center font-weight-bold"><a href="https://colaboracion.dnp.gov.co/CDT/Prensa/BasesPND2018-2022n.pdf" target="_blank">PND {{periodoselect}}, PPI PAZ.</a> </div>
              <hr>
              <br>
              <v-card>
                <v-card-title>
                  Apropiación presupuestal para la implementación del Acuerdo Final de Paz
                </v-card-title>
                
                <v-card-text>
                  <v-flex row class="container">
                    <v-flex xs12 sm10 md10 >
                      Conozca los recursos financieros <b>apropiados</b> para la Implementación de los Acuerdos de Paz, por cada una de las fuentes de financiación y puntos.
                    </v-flex>
                    <v-flex xs12 sm2 md2 >
                      <v-select
                        :items="recursoplurianual.vigencias"
                        v-model="vigenciaselect"
                        item-text="nombre"
                        item-value="valor"
                        label="Vigencia"
                        @change="APPfilterVigencia"
                      ></v-select>
                    </v-flex>
                  </v-flex>
                  <hr>
                  <br>
                    <dona :cifras= cifrasPPI titulo1="POR FUENTE DE FINANCIACIÓN" titulo2="POR PUNTO DEL ACUERDO" :avances1="RecursoPluGenFuente" :avances2="RecursoPluGenPunto" nameseries1="nombre" nameseries2="nombre" :links2="LinksApresupuestal" id1="PluD1" id2="PluD2" />
                    <br>
                  <v-flex row class="container">
                    <v-flex xs6 sm6 md6 >
                      <v-alert border="left" colored-border dense color="blue darken-1" elevation="2"  type="info">
                        <font size=2 class="text" style="text-align: justify;"> El dato del presupuesto General de la Nación sólo incluye el presupuesto de inversión nacional más los recursos de la Bolsa Paz por funcionamiento.
                        </font>
                      </v-alert>   
                    </v-flex>  
                    <v-flex xs6 sm6 md6 >
                    </v-flex>                     
                  </v-flex>              
                </v-card-text>
              </v-card>   
              <hr>
              <div class="Subtitle-2 text-center font-weight-bold">Fecha de corte: 31 diciembre de {{vigenciaselect}}</div>
              <v-card>
                <v-card-title>
                  Mapa de inversiones
                </v-card-title>                
                <v-card-text>
                  Conozca el visor de la ejecución de los recursos de los proyectos de inversión pública.
                  <p>
                    <link rel="stylesheet" href="">
                    <a href="https://mapainversiones.dnp.gov.co/" target="_blank">https://mapainversiones.dnp.gov.co/</a>
                  </p>
                </v-card-text>
              </v-card>
             
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <v-card-title>Presupuesto General de la Nación para la implementación del Acuerdo Final de Paz</v-card-title>
                <v-card-text>
                  <v-flex row class="container">
                    <v-flex xs12 sm10 md10 >                  
                      Conozca la apropiación de los recursos del Presupuesto General de la Nación destinados a la implementación del Acuerdo, identificados por el trazador presupuestal <i> construcción de paz </i>.
                    </v-flex>
                  <v-flex xs12 sm2 md2>
                    <v-select
                      :items="DataVigencia"
                      v-model="vigenciaseleccionada"
                      item-text="vigencia"
                      item-value="vigencia"
                      label="Vigencia"
                      @change="filterVigencia"
                    ></v-select>
                  </v-flex>
                  </v-flex>
                  <hr>
                  <br>
                    <dona titulo1="POR TIPO DE GASTO" titulo2="POR PUNTO DEL ACUERDO" :avances1="DataTipoGasto" :avances2="DataPresupuesto" nameseries1="tipogasto" nameseries2="nombrePunto" :links1="LinksPGeneral" id1="Gen1" id2="Gen2" />
                </v-card-text>
              </v-card>
              <hr>
              <div v-if="vigenciaseleccionada != ''" class="Subtitle-2 text-center font-weight-bold">Cifras en billones de pesos corrientes de {{ vigenciaseleccionada }}</div>
              <div v-if="gtipogastos.length > 0" class="Subtitle-2 text-center font-weight-bold">Fecha de corte: {{ gtipogastos[0].fechacorte }}</div>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
  </v-container>
</template>
<script>
// let url = process.env.BASE_URL;
import * as am4core from "@amcharts/amcharts4/core";
// import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import dona from "../../components/chart/dona.vue";
import recursoplurianual from "../../stores/data/recursoplurianual.json";

// import store from "../../stores/index.js"
// import moment from 'moment'
am4core.useTheme(am4themes_animated);

import { mapActions, mapGetters } from "vuex";
export default {
  name: "recursosfinancieros",
  components: {
    dona
  },
  data() {
    return {
      LinksPGeneral:[ 
        {link: "/recursosinversion", nombre: "Inversión"},
        {link: "/recursosfuncionamiento", nombre: "Funcionamiento"}, ],
      LinksApresupuestal: [],
      cifrasPPI: "",
      recursoplurianual,
      periodoselect: 0,
      vigenciaselect: 0,
      DataVigencia: [],
      vigenciaseleccionada: 2019,
      DataTipoGasto: [],
      DataPresupuesto: [],
      TabSeleccionado:"",
      RecursoPluGenPunto: [],
      RecursoPluGenFuente: [],
      marcofiscalpunto:[],
      marcofiscalfuente:[],
      marcofiscalcifra: '',
      plurianualcifra: '',
      plurianualcorte: '',
      plurianualcifradetallado: []
    }
  },
  methods: {
    ...mapActions([
      "get_presupuestosbypunto",
      "get_tipogastos",
      "get_vigencias",
      "get_recursomarcofiscal",
      "get_recursocifras",
      "get_rplurianualgrouppunto",
    ]),
    filterVigencia() {
      this.filtrarTipoGasto();
      this.filtarPresupuesto();
      localStorage.setItem("vigenciaseleccionada", this.vigenciaseleccionada);
    },
    APPfilterVigencia() {
      this.filtarPlurGenPunto();
      this.filtrarPluGenFuente()
    },
    filtarPlurGenPunto() {
      this.RecursoPluGenPunto = this.gplurianualgrouppunto.filter(record => { return record.vigencia == this.vigenciaselect; });
    },
    filtrarPluGenFuente(){
      this.RecursoPluGenFuente = this.recursoplurianual.detallado.Agrup_fuente.filter(record => { return record.vigencia == this.vigenciaselect; });
    },
    filtrarTipoGasto(){
      this.DataTipoGasto= [];
      let vigencia = this.vigenciaseleccionada
      if (this.gtipogastos.length > 0)
      this.DataTipoGasto = this.gtipogastos.filter(record => {
        return record.vigencia == vigencia;
      });

    }, 
    filtarPresupuesto(){
      let vigencia = this.vigenciaseleccionada
      this.DataPresupuesto = [];
      this.DataPresupuesto = this.gpresupuestos.filter(record => {
        return record.vigencia == vigencia;
      });
      
    },
    ontabseleccionado(val){
      this.$store.dispatch("setselectedtab", val);
    }
  },
  created(){
    this.get_presupuestosbypunto();
    this.get_recursomarcofiscal();
    this.get_tipogastos();
    this.get_vigencias();
    this.get_recursocifras();
    this.get_rplurianualgrouppunto();

    this.TabSeleccionado = this.$store.getters.gtabseleccionado;
    this.periodoselect = recursoplurianual.periodos.filter(record => {
      return record.defaul === 1;
    })[0].valor;
    this.vigenciaselect = recursoplurianual.vigencias.filter(record => {
      return record.defaul === 1;
    })[0].valor;  
  },
  mounted() {
    if (localStorage.vigenciaseleccionada != undefined)
      this.vigenciaseleccionada = parseInt(localStorage.vigenciaseleccionada)
  },
  computed:{
    ...mapGetters([
      "gpresupuestos",
      "gtipogastos",
      "gvigencias",
      "gtabseleccionado",
      "grmarcofiscal",
      "grcifras",
      "gplurianualgrouppunto"
    ]),
    ...mapGetters("mensaje", ["ginformation", "gnodata", "glogo"]),
    
  },
  watch: {
    
    gvigencias: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.DataVigencia = [];
        this.DataVigencia = this.gvigencias.filter(p=> p.vigencia <= 2023);
      }
    },
    gtipogastos: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.filtrarTipoGasto();
      }
    },
    gpresupuestos: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
          this.filtarPresupuesto();
      }
    },
    grmarcofiscal: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.marcofiscalpunto = this.grmarcofiscal.filter(record => {
          return record.tipo == "punto";
        });
        this.marcofiscalfuente = this.grmarcofiscal.filter(record => {
          return record.tipo == "fuente";
        });        
      }
    },
    grcifras: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.marcofiscalcifra = this.grcifras.filter( record => {return record.tipo == "MarcoFiscal";})[0];
        this.plurianualcifra = this.grcifras.filter( record => {return record.tipo == "RecursoPlurianualcifracuatrenio2018-2022";})[0];
        
        this.plurianualcorte = this.grcifras.filter( record => {return record.tipo == "RecursoPlurianualCorte";})[0];
        this.plurianualcifradetallado = this.grcifras.filter( record => {return record.tipo == "RecursoPlurianualcifradetallado";})[0];
      }
    },
    gplurianualgrouppunto: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.APPfilterVigencia(); 
        this.LinksApresupuestal = []; 
        this.gplurianualgrouppunto.forEach(element => {
          if (element.vigencia == parseInt(this.vigenciaselect) )
            this.LinksApresupuestal.push({link: "/recursosapropiacionpresup/" + element.idpunto + "/" + element.vigencia, nombre: element.nombre },)
        });
      }
    },
    vigenciaselect: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.cifrasPPI = "Informe del PPI Paz " + this.vigenciaselect + " - Billones de pesos corrientes de " + this.vigenciaselect;
        if (this.gplurianualgrouppunto.length > 0){
          this.LinksApresupuestal = [];
          this.gplurianualgrouppunto.forEach(element => {
            if (element.vigencia == parseInt(this.vigenciaselect) )
              this.LinksApresupuestal.push({link: "/recursosapropiacionpresup/" + element.idpunto + "/" + element.vigencia, nombre: element.nombre },)
          });      
        }  
      }
    }
  }
}
</script>